import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeFr from '@angular/common/locales/fr';
import { SUPPORTED_LANGUAGES, SupportedLanguage } from './supported-languages';

export type SupportedLocale = SupportedLanguage | `${SupportedLanguage}-${string}`;

export function getSupportedLocale(): SupportedLocale {
  const browserLang = navigator.language;
  const langCode = extractLangCode(browserLang);
  return (SUPPORTED_LANGUAGES as string[]).includes(langCode) ? (browserLang as SupportedLocale) : 'en-US';
}
const languageToLocalePackage: Record<SupportedLanguage, unknown> = {
  en: null,
  fr: localeFr,
  de: localeDe,
};

export function registerSupportedLocaleData(locale: SupportedLocale) {
  const langCode = extractLangCode(locale) as SupportedLanguage;
  const data = languageToLocalePackage[langCode];
  if (data) {
    registerLocaleData(data);
  }
}

function extractLangCode(locale: string) {
  return locale.split('-')[0];
}
